import styled from 'styled-components';
import { Table as AntdTable } from 'antd';
import { FONT_SIZE } from '@app/styles/themes/constants';
import { BaseTableProps } from './BaseTable';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- styled() needs the same open record type antd's Table declares; narrowing it breaks every call site
export const Table = styled(AntdTable)<BaseTableProps<any>>`
  & .ant-table {
    background: transparent;
  }

  background: transparent;

  & thead .ant-table-cell {
    font-size: ${FONT_SIZE.xs};
    line-height: 1.25rem;

    & .anticon {
      color: var(--primary-color);
    }
  }

  & tbody .ant-table-cell {
    color: var(--text-main-color);
    font-size: ${FONT_SIZE.xs};
    line-height: 1.25rem;

    // text-transform: capitalize;

    &.no-text-transform {
      text-transform: none;
    }
  }

  & tbody .ant-table-row-expand-icon {
    width: 16px !important;
    height: 16px !important;
    min-height: 16px;
    min-width: 16px;
    font-size: 0 !important;
    position: relative;
    border-radius: 0.1875rem;
    margin-top: 0;
    border-color: var(--primary-color);

    &:focus,
    &:hover {
      border-color: var(--primary-color);
    }

    /* center the plus/minus lines */
    &::before,
    &::after {
      content: '';
      position: absolute;
      background: currentColor;
      transition: all 0.2s;
    }

    /* vertical line (for '+') */
    &::before {
      top: 7px;
      left: 50%;
      width: 9px;
      transform: translateX(-50%);
    }

    /* horizontal line (always shown) */
    &::after {
      left: 7px;
      top: 50%;
      height: 9px;
      transform: translateY(-50%);
    }

    /* collapsed state shows both lines (the '+') */
    &.ant-table-row-expand-icon-collapsed::after {
      opacity: 1;
    }

    /* expanded state hides vertical line (turns into '–') */
    &.ant-table-row-expand-icon-expanded::after {
      opacity: 0;
    }
  }

  & .ant-table-thead {
    background: var(--highlighting-color);
    border-radius: 10px;

    //.ant-table-cell {
    // text-transform: capitalize;
    //}
  }

  // Override default antd selector
  &
    .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: transparent;
  }

  .ant-table-pagination.ant-pagination {
    margin: 16px;
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled),
  .ant-mentions-dropdown-menu-item-active,
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background: var(--highlighting-color);
  }

  & .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next,
  .ant-pagination-item {
    min-width: 2.0625rem;
    height: 2.0625rem;
    line-height: 2.0625rem;
    border-radius: 0;
    font-size: ${FONT_SIZE.xs};
    background: transparent;
    border: 0px;
  }

  & .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    border-radius: 0;
    background: transparent;
    border: 0px;
  }

  & .ant-checkbox-inner {
    border-radius: 0.1875rem;
    height: 1.25rem;
    width: 1.25rem;
    border: 1px solid var(--primary-color);
  }

  & .editable-row .ant-form-item-explain {
    position: absolute;
    top: 100%;
    font-size: 0.75rem;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: var(--highlighting-color-table-row);
  }

  .ant-table-column-sort {
    background-color: transparent;
  }

  .ant-pagination-item-container .ant-pagination-item-ellipsis {
    color: var(--disabled-color);
  }

  .ant-pagination-item-active {
    background: var(--highlighting-color);
    border-radius: 4px;
  }

  .ant-pagination-disabled {
    .ant-pagination-item-link,
    .ant-pagination-item a {
      color: var(--disabled-color);
    }
  }

  .ant-pagination.ant-pagination-disabled {
    .ant-pagination-item-link,
    .ant-pagination-item a {
      color: var(--disabled-color);
    }
  }

  .ant-pagination-options {
    .ant-select-selector {
      height: 35px;
      background-color: var(--highlighting-color);
    }
    .ant-select-selection-item {
      line-height: 35px;
    }

    .ant-select-arrow {
      color: var(--text-color-secondary-color);
    }
  }

  .ant-table.ant-table-bordered > .ant-table-container,
  .ant-table-row > *,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th,
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th {
    border: 0px;
  }

  li.ant-pagination-options > div {
    height: 100%;
  }

  .anticon-caret-up.ant-table-column-sorter-up.active {
    color: var(--text-main-color);
  }

  .anticon-caret-down.ant-table-column-sorter-down.active {
    color: var(--text-main-color);
  }

  ${({ light }) =>
    light &&
    `
    & tbody .ant-table-cell {
      color: var(--text-dark-color);
    }
  
    && thead .ant-table-cell {
      color: var(--text-dark-color);
    }
  
    && tbody .ant-table-cell {
      border-bottom: 1px solid var(--highlighting-dark-color) !important;
    }
  `}

  &&&.ant-table-wrapper {
    width: 100%;
  }
`;
